import {_utils} from "../../utils/_utils.js";
import {_libs} from "../../utils/_libs.js";
import {_state} from "../../state/state.js";

export const sectionWithGsap = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.section-with-gsap', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    let tl = null;

    const createTL = () => {
        if(tl !== null){
            tl.scrollTrigger.kill(true);
            tl.kill();
            tl = null;
        }

        _libs._gsap({
            trigger: section,
            start: 'top top',
            end: `bottom bottom`,
            scrub: true,
            pin: false,
            pinSpacing: false,
            //markers: true,
        })
    }
    createTL();

    const rebuildFunc = () => {
        if(_state.isUserActive){
            createTL();
        }
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}